import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/takeUntil';
import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import {Action} from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import * as contact from '../actions/contact';
import * as auth from '../actions/authentication';
import {ContactService} from '../services/contact';
import * as routerActions from '../actions/router';
import {Contact} from '../models/contact';
import { ErrorModel } from '../models/error-model';

@Injectable()
export class ContactEffects {

  @Effect()
  loadAllContacts$: Observable<Action> = this.actions$
    .ofType(contact.LOAD_CONTACT_LIST)
    .map((action: contact.LoadContactListAction) => action.payload)
    .switchMap(pm => {

      const nextLookup$ = this.actions$.ofType(contact.LOAD_CONTACT_LIST).skip(1);
      const errorMessage = 'Error loading contact list.';
      return this.contactService.loadContacts(pm)
        .takeUntil(nextLookup$)
        .map(p => new contact.LoadContactListCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  saveContact$: Observable<Action> = this.actions$
    .ofType(contact.SAVE_CONTACT)
    .map((action: contact.SaveContactAction) => action.payload)
    .switchMap(ct => {

      const nextLookup$ = this.actions$.ofType(contact.SAVE_CONTACT).skip(1);
      const errorMessage = 'Error saving contact.';

      return this.contactService.updateContact(ct)
        .takeUntil(nextLookup$)
        .map(p => {
          const rtrn = Object.assign({}, ct) as Contact;
          rtrn.id = p;
          return new contact.SaveContactCompleteAction(rtrn);
        })
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  saveContactComplete$: Observable<Action> = this.actions$
    .ofType(contact.SAVE_CONTACT_COMPLETE)
    .map(() => new routerActions.Go({ path: ['admin', 'contacts']}));

  @Effect()
  loadContactById$: Observable<Action> = this.actions$
    .ofType(contact.GET_CONTACT_DETAILS)
    .map((action: contact.GetContactDetailsAction) => action.payload)
    .switchMap(id => {

      const nextLookup$ = this.actions$.ofType(contact.GET_CONTACT_DETAILS).skip(1);
      const errorMessage = 'Error retrieving contact information.';
      return this.contactService.getContactById(id)
        .takeUntil(nextLookup$)
        .map(p => new contact.GetContactDetailsCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  loadUserProfile$: Observable<Action> = this.actions$
    .ofType(contact.GET_USER_PROFILE)
    .map((action: contact.GetUserProfileAction) => action.payload)
    .switchMap(id => {

      const nextLookup$ = this.actions$.ofType(contact.GET_USER_PROFILE).skip(1);
      const errorMessage = 'Error loading user profile.';

      return this.contactService.getContactByUsername(id)
        .takeUntil(nextLookup$)
        .map(p => {
          return new contact.GetUserProfileCompleteAction(p);
        })
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  saveProfile$: Observable<Action> = this.actions$
    .ofType(contact.SAVE_USER_PROFILE)
    .map((action: contact.SaveUserProfileAction) => action.payload)
    .switchMap(ct => {

      const nextLookup$ = this.actions$.ofType(contact.SAVE_USER_PROFILE).skip(1);
      const errorMessage = 'Error saving user profile.';
      return this.contactService.updateContact(ct)
        .takeUntil(nextLookup$)
        .map(p => {
          const rtrn = Object.assign({}, ct) as Contact;
          rtrn.id = p;
          return new contact.SaveUserProfileCompleteAction(rtrn);
        })
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  saveProfileComplete$: Observable<Action> = this.actions$
    .ofType(contact.SAVE_USER_PROFILE_COMPLETE)
    .map(() => new routerActions.Go({ path: ['']}));

  constructor(private actions$: Actions, private contactService: ContactService) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/effects/contact.ts